<template>
<div class="filter-range">
    <div class="filter-range__from">
        <SimpleInput :inputName="`${params.name} от`" :inputValue="inputValueFrom" @input-value-emitter="updateValueFrom" />
    </div>
    <div class="filter-range__to">
        <SimpleInput :inputName="`${params.name} до`" :inputValue="inputValueTo" @input-value-emitter="updateValueTo" />
    </div>
</div>
</template>

<script>
import SimpleInput from "@/components/UI/inputs/SimpleInput.vue";

export default {
    name: "FilterInput",
    components: {SimpleInput},
    props: {
        params: {
            type: Object,
        },
        value: {
            type: Array,
        },
    },
    data() {
        return {
            inputValueFrom: this.value
                ? this.value[0] || ''
                : '',
            inputValueTo: this.value
                ? this.value[1] || ''
                : '',
        };
    },
    methods: {
        updateValueFrom({value}) {
            this.inputValueFrom = value;
            this.emitValue();
        },
        updateValueTo({value}) {
            this.inputValueTo = value;
            this.emitValue();
        },
        emitValue() {
            if (this.inputValueFrom || this.inputValueTo) {
                this.$emit('input', [this.inputValueFrom, this.inputValueTo]);
            } else {
                this.$emit('input', null);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/rem";

.filter-range {
    display: block !important;

    &__from {
      margin-bottom: mrem(16);

      @include on-desktop {
          margin-bottom: rem(16);
      }
    }
}
</style>